export default __webpack_public_path__ + "static/media/Rep.848e4ea1.svg";